var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.663 2.50003H2.32971C0.659589 2.50003 0.666504 4.16802 0.666504 4.16802L0.666506 17.5014C0.666506 19.1667 2.32971 19.1667 2.32971 19.1667H15.663C15.663 19.1667 17.3332 19.168 17.3332 17.5014V4.16802C17.3332 4.16802 17.3297 2.50003 15.663 2.50003ZM2.33205 4.99768C2.33205 4.16668 3.16539 4.16434 3.16539 4.16434H14.8321C14.8321 4.16434 15.6654 4.16434 15.6654 4.99768V16.6643C15.6654 17.4977 14.8321 17.4977 14.8321 17.4977H3.16539C3.16539 17.4977 2.33205 17.4977 2.33205 16.6643V4.99768Z",
    fill: "#777776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50157 9.16517C1.04133 9.16517 0.668233 8.79208 0.668233 8.33184C0.668233 7.8716 1.04133 7.4985 1.50157 7.4985H16.5016C16.9618 7.4985 17.3349 7.8716 17.3349 8.33184C17.3349 8.79208 16.9618 9.16517 16.5016 9.16517H1.50157Z",
    fill: "#777776"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4998 1.66634C11.4998 1.2061 11.8729 0.833008 12.3332 0.833008C12.7934 0.833008 13.1665 1.2061 13.1665 1.66634V4.99967C13.1665 5.45991 12.7934 5.83301 12.3332 5.83301C11.8729 5.83301 11.4998 5.45991 11.4998 4.99967V1.66634Z",
    fill: "#777776"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83317 1.66634C4.83317 1.2061 5.20627 0.833008 5.6665 0.833008C6.12674 0.833008 6.49984 1.2061 6.49984 1.66634V4.99967C6.49984 5.45991 6.12674 5.83301 5.6665 5.83301C5.20627 5.83301 4.83317 5.45991 4.83317 4.99967V1.66634Z",
    fill: "#777776"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.c03be9af.svg";
export { ForwardRef as ReactComponent };